import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { usePricingContext } from '../../../contexts/pricing-context';
export var PageSectionPB = function (props) {
    var isMobile = props.isMobile, children = props.children, classes = props.classes, title = props.title, type = props.type;
    var shouldShowPricingBookPage = usePricingContext().shouldShowPricingBookPage;
    var fontSize = isMobile ? 'sui-text-xl' : 'sui-text-5xl';
    var showNationalAccountNewTitle = type === 'NAI' && shouldShowPricingBookPage;
    var renderTitle = function () {
        if (!title)
            return null;
        if (showNationalAccountNewTitle) {
            return (React.createElement(Typography, { variant: "h2", color: "primary", weight: "display", uppercase: true, "data-testid": "PageSectionPB__new__header__title" }, title));
        }
        return (React.createElement("div", { "data-testid": "PageSectionPB__header", className: "sui-h-11 sui-border-solid sui-border-primary sui-border-b-1" },
            React.createElement("span", { className: "sui-border-solid sui-border-b-2 sui-border-accent ".concat(fontSize), "data-testid": "PageSectionPB__header__title" }, title)));
    };
    return (React.createElement("div", { className: "sui-w-full sui-mb-10", "data-testid": "PageSectionPB" },
        renderTitle(),
        React.createElement("div", { "data-testid": "PageSectionPB__content" },
            React.createElement("div", { className: classes }, children))));
};
